import { CAMPAIGN_RECEIVE } from '../Actions/Campaign.action';

const DEFAULT_STATE = {
    query: '',
    listObjects: [],
};

export const campaign = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
    case CAMPAIGN_RECEIVE:
        return {
            ...state,
            ...action.payload,
        };
    default:
        return state;
    }
}